export const loading = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
    top: 0,
    left: 0
};

export const spinner = {
    width: '150px',
    height: '150px'
};
